import React from "react";
import { MenuItem, ListItemIcon, Typography, Tooltip } from "@mui/material";
import { styled } from "@mui/system";

const TSMenuItemStyled = styled(MenuItem)(({ theme, disabled }) => ({
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.5 : 1,
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: disabled ? "transparent" : theme.palette.action.hover || "rgba(0, 0, 0, 0.08)",
  },
  "&.MuiButtonBase-root.MuiMenuItem-root": {
    display: "flex",
    padding: "12px 25px",
    cursor: disabled ? "not-allowed" : "pointer",
  },
  "& .MuiListItemIcon-root": {
    minWidth: "36px",
    color: disabled ? "#9e9e9e" : "#242F3F",
    "& svg": {
      width: "20px",
      height: "20px",
    },
  },
  "&:last-child .MuiListItemIcon-root": {
    color: disabled ? "#9e9e9e" : "#FF310E",
  },
  "& .MuiTypography-root": {
    fontSize: "14px",
    fontWeight: 500,
    color: disabled ? "#9e9e9e" : "#2B3539",
  },
  "&:last-child .MuiTypography-root": {
    color: disabled ? "#9e9e9e" : "#FF310E",
  },
}));

const WarningTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  "& .MuiTooltip-tooltip": {
    backgroundColor: "#ff9800",
    color: "#fff",
    fontSize: "13px",
    fontWeight: 500,
    padding: "8px 12px",
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(255, 152, 0, 0.3)",
  },
  "& .MuiTooltip-arrow": {
    color: "#ff9800",
  },
});

const TSMenuItem = ({
  icon,
  text,
  onClick,
  endIcon,
  onMouseEnter,
  disabled = false,
  tooltip = "",
  onDisabledHover,
}) => {
  const handleMouseEnter = (e) => {
    if (disabled) {
      if (onDisabledHover) {
        onDisabledHover();
      }
    } else if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  const menuItem = (
    <TSMenuItemStyled
      onClick={disabled ? undefined : onClick}
      onMouseEnter={handleMouseEnter}
      disabled={disabled}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <Typography>{text}</Typography>
      {endIcon && <ListItemIcon sx={{ ml: 6 }}>{endIcon}</ListItemIcon>}
    </TSMenuItemStyled>
  );

  if (disabled && tooltip) {
    return (
      <WarningTooltip title={tooltip} placement="right" arrow>
        <span>{menuItem}</span>
      </WarningTooltip>
    );
  }

  return menuItem;
};

export default TSMenuItem;
